<template>
    <div class="mb-lg">
        <div class="form-group" :class="wrapperClasses">
            <input
                v-validate="hasValidations ? $attrs['validations'] : null"
                :data-vv-as="hasValidations ? label : null"
                class="input"
                :type="type"
                :class="textInputClasses"
                :autofocus="autofocus"
                :value="value"
                :name="name"
                :required="required"
                :placeholder="nativeLabel"
                :disabled="disabled"
                :pattern="pattern"
                :title="title"
                autocomplete="off"
                :tabindex="tabindex"
                :inputmode="inputmode"
                @input="$emit('input', $event.target.value)"
                @keydown.down="$emit('down')"
                @keydown.up="$emit('up')"
                @keydown.enter="$emit('enter')"
                @keydown.esc="$emit('esc')"
            >

            <label
                v-if="label"
                :for="`input-${name}`"
                class="floating-label"
            >
                {{ label }}
                <span
                    v-if="help"
                    class="text-xs italic"
                >
                    ({{ help }})
                </span>
            </label>

            <font-awesome-icon
                v-if="hasValidations && ! errors.has(name)"
                icon="check-circle"
            />
            <font-awesome-icon
                v-else-if="hasValidations"
                icon="exclamation-circle"
            />

            <font-awesome-icon
                v-if="icon"
                :icon="icon"
                :class="iconClasses"
                :size="iconSize"
                @click="$emit('clicked-icon')"
            />
        </div>

        <span v-if="hasValidations && errors.first(name)" class="h-md block">
            <span class="form-error">
                {{ errors.first(name) }}
            </span>
        </span>
    </div>
</template>

<script>
    import TextInput from '../../Atlantis/Forms/TextInput';

    export default {
        extends: TextInput,
        computed: {
            // NB! We need to override some computed properties that rely on validation

            wrapperClasses() {
                return {
                    'form-group-floating-label': this.label,
                    'has-icon': this.icon,
                    'has-icon can-have-errors': this.hasValidations,
                };
            },
            iconPositionClasses() {
                const iconPosition = `has-icon-${this.iconPlacement}`;
                return {
                    [iconPosition]: this.icon,
                };
            },
            textInputClasses() {
                return {
                    ...this.iconPositionClasses,
                    ...this.inputClasses,
                    ... {
                        'has-icon-right': this.hasValidations,
                    },
                };
            },
        },
    };
</script>
